import React from 'react'

class LeavePlanActivationLink extends React.Component {
  handleClick () {
    PubSub.publish('openJustLookingModal:onClick')
  }

  render () {
    return (
      <div>
        <button className='btn btn-dark btn-bdr-rds btn-block' onClick={this.handleClick}>
          Activate LeavePlan
        </button>
      </div>
    )
  }
}

export default LeavePlanActivationLink